import { createNavigation } from 'next-intl/navigation'
import { defineRouting } from 'next-intl/routing'
import { defaultLocale, locales } from './config'

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: 'as-needed',
  // Ohne diesen Schalter leitet next-intl jede deutsche URL per 307 auf die
  // englische Variante um, sobald der Client Accept-Language: en sendet.
  // Googlebot crawlt ueberwiegend mit englischem Accept-Language, bekam also
  // auf /leistungen ein 307 auf /en/services. Google rät ausdruecklich von
  // automatischer Sprachumleitung ab, und die deutschen Seiten sind der
  // Hauptmarkt. Sprachwechsel laeuft ueber den Umschalter im Header.
  localeDetection: false,
  // Kein automatischer hreflang-Link-HTTP-Header: bei dynamischen [slug]-Routen
  // kennt die Middleware unsere DE<->EN-Slug-Zuordnung nicht und wuerde gekreuzte
  // Slugs ausliefern (z. B. en -> /en/services/markenidentitaet statt brand-identity),
  // was dem korrekten hreflang im HTML widerspricht (Ahrefs: "more than one page per
  // language"). Wir liefern hreflang vollstaendig und korrekt ueber Metadata im HTML.
  alternateLinks: false,
  pathnames: {
    '/': '/',
    '/leistungen': {
      en: '/services',
      de: '/leistungen'
    },
    '/leistungen/[slug]': {
      en: '/services/[slug]',
      de: '/leistungen/[slug]'
    },
    '/leistungen/technologie': {
      en: '/services/technology',
      de: '/leistungen/technologie'
    },
    '/projekte': {
      en: '/projects',
      de: '/projekte'
    },
    '/projekte/[slug]': {
      en: '/projects/[slug]',
      de: '/projekte/[slug]'
    },
    '/about': '/about',
    // Einstieg ueber die Lage des Kunden, verlinkt auf die passenden Landingpages
    '/wo-wir-helfen': {
      en: '/how-we-help',
      de: '/wo-wir-helfen'
    },
    // Partnerseite zum Stripe Partner Ecosystem. Slug in beiden Sprachen gleich,
    // weil "Stripe Partner" der Eigenname des Programms ist.
    '/stripe-partner': '/stripe-partner',
    '/news': '/news',
    '/news/[slug]': '/news/[slug]',
    // NotFair-SEO-Beiträge. /en/blog/<slug> ist das englische Original von NotFair,
    // /blog/<slug> die deutsche Übersetzung (siehe modules/blog/localize-post.ts).
    '/blog/[slug]': '/blog/[slug]',
    '/kontakt': {
      en: '/contact',
      de: '/kontakt'
    },
    '/kostenlose-beratung': {
      en: '/free-consultation',
      de: '/kostenlose-beratung'
    },
    '/agentur': {
      en: '/agency',
      de: '/agentur'
    },
    '/kostenlose-ki-analyse': {
      en: '/free-ai-analysis',
      de: '/kostenlose-ki-analyse'
    },
    '/agentur/webagentur-fuerth': {
      en: '/agency/web-agency-fuerth',
      de: '/agentur/webagentur-fuerth'
    },
    '/agentur/webagentur-nuernberg': {
      en: '/agency/web-agency-nuremberg',
      de: '/agentur/webagentur-nuernberg'
    },
    '/agentur/e-commerce-agentur-fuerth': { en: '/agency/e-commerce-agency-fuerth', de: '/agentur/e-commerce-agentur-fuerth' },
    '/agentur/e-commerce-agentur-nuernberg': { en: '/agency/e-commerce-agency-nuremberg', de: '/agentur/e-commerce-agentur-nuernberg' },
    '/agentur/ki-agentur-fuerth': { en: '/agency/ai-agency-fuerth', de: '/agentur/ki-agentur-fuerth' },
    '/agentur/ki-agentur-nuernberg': { en: '/agency/ai-agency-nuremberg', de: '/agentur/ki-agentur-nuernberg' },
    '/agentur/woocommerce-agentur-nuernberg': { en: '/agency/woocommerce-agency-nuremberg', de: '/agentur/woocommerce-agentur-nuernberg' },
    '/agentur/woocommerce-agentur-fuerth': { en: '/agency/woocommerce-agency-fuerth', de: '/agentur/woocommerce-agentur-fuerth' },
    '/agentur/wordpress-agentur-nuernberg': { en: '/agency/wordpress-agency-nuremberg', de: '/agentur/wordpress-agentur-nuernberg' },
    '/agentur/wordpress-agentur-fuerth': { en: '/agency/wordpress-agency-fuerth', de: '/agentur/wordpress-agentur-fuerth' },
    '/agentur/shopify-agentur-nuernberg': { en: '/agency/shopify-agency-nuremberg', de: '/agentur/shopify-agentur-nuernberg' },
    '/agentur/shopify-agentur-fuerth': { en: '/agency/shopify-agency-fuerth', de: '/agentur/shopify-agentur-fuerth' },
    '/ki': {
      en: '/ai',
      de: '/ki'
    },
    '/ki/ki-agenten': {
      en: '/ai/ai-agents',
      de: '/ki/ki-agenten'
    },
    '/ki/ki-chatbot': {
      en: '/ai/ai-chatbot',
      de: '/ki/ki-chatbot'
    },
    '/ki/ki-automatisierung-shopify': {
      en: '/ai/ai-automation-shopify',
      de: '/ki/ki-automatisierung-shopify'
    },
    '/ki/ki-automatisierung-woocommerce': {
      en: '/ai/ai-automation-woocommerce',
      de: '/ki/ki-automatisierung-woocommerce'
    },
    '/ki/ki-beratung': {
      en: '/ai/ai-consulting',
      de: '/ki/ki-beratung'
    },
    '/lp/b2b-e-commerce': '/lp/b2b-e-commerce',
    '/lp/e-commerce-agentur': {
      en: '/lp/e-commerce-agency',
      de: '/lp/e-commerce-agentur'
    },
    '/lp/fashion-e-commerce': '/lp/fashion-e-commerce',
    '/lp/shopify-agentur': {
      en: '/lp/shopify-agency',
      de: '/lp/shopify-agentur'
    },
    '/lp/shopify-betreuung': {
      en: '/lp/shopify-support',
      de: '/lp/shopify-betreuung'
    },
    '/lp/woocommerce-agentur': {
      en: '/lp/woocommerce-agency',
      de: '/lp/woocommerce-agentur'
    },
    '/lp/shopware-agentur': {
      en: '/lp/shopware-agency',
      de: '/lp/shopware-agentur'
    },
    '/lp/sap-commerce-cloud': '/lp/sap-commerce-cloud',
    '/lp/wordpress-agentur': {
      en: '/lp/wordpress-agency',
      de: '/lp/wordpress-agentur'
    },
    '/lp/app-entwicklung': {
      en: '/lp/app-development',
      de: '/lp/app-entwicklung'
    },
    '/lp/individuelle-software': {
      en: '/lp/custom-software',
      de: '/lp/individuelle-software'
    },
    '/lp/ki-automatisierung': {
      en: '/lp/ai-automation',
      de: '/lp/ki-automatisierung'
    },
    '/lp/website-betreuung': {
      en: '/lp/website-maintenance',
      de: '/lp/website-betreuung'
    },
    '/lp/woocommerce-betreuung': {
      en: '/lp/woocommerce-support',
      de: '/lp/woocommerce-betreuung'
    },
    '/lp/wordpress-wartung': {
      en: '/lp/wordpress-maintenance',
      de: '/lp/wordpress-wartung'
    },
    '/lp/woocommerce-migration': '/lp/woocommerce-migration',
    '/lp/ki-agentur-mittelstand': {
      en: '/lp/ai-agency-for-smes',
      de: '/lp/ki-agentur-mittelstand'
    },
    '/lp/woocommerce-vs-shopify-b2b': '/lp/woocommerce-vs-shopify-b2b',
    '/lp/online-shop-entwicklung': {
      en: '/lp/online-store-development',
      de: '/lp/online-shop-entwicklung'
    },
    '/[slug]': '/[slug]',
    '/impressum': {
      en: '/legal-notice',
      de: '/impressum'
    },
    '/datenschutz': {
      en: '/privacy-policy',
      de: '/datenschutz'
    },
    '/cookie-richtlinien': {
      en: '/cookie-policy',
      de: '/cookie-richtlinien'
    },
    '/plugins': '/plugins',
    // kein physisches [slug]-Verzeichnis, aber als typisiertes Link-Template
    // in der Plugin-Uebersicht in Verwendung
    '/plugins/[slug]': '/plugins/[slug]',
    '/plugins/revoker': '/plugins/revoker',
    '/plugins/revoker/success': '/plugins/revoker/success'
  } as const
})

export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
